<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <title-edit header="Location" />
    <line-hr />
    <v-app class="switch-app">
    </v-app>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Mini TCDC :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option :items="optionMiniTCDC" :model="form.tcdc_mini_id" @update="updateTcdcMini" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description TH :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor id="1" :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description EN :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor id="2" :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Latitude* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.lat" @update="updateLat" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Longitude* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.lon" @update="updateLon" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Address TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.address_th" @update="updateAddressTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Address EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.address_en" @update="updateAddressEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Postal address TH :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.postal_address_th" @update="updatePostalAddressTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Postal address EN :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.postal_address_en" @update="updatePostalAddressEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Opening hours detail TH :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.opening_hours_detail_th" @update="updateOpeningHoursDetailTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Opening hours detail EN :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.opening_hours_detail_en" @update="updateOpeningHoursDetailEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Attached website :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.attached_website" @update="updateAttachedWebsite" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Service area title th :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.service_area_title_th" @update="updateServiceAreaTitleTh" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Service area title en :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.service_area_title_en" @update="updateServiceAreaTitleEn" />
      </v-col>
    </div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" align="center" justify="center">
        <submit-button label="+ opening hours" @click.native="showOpeningHour" />
      </v-col>
      <v-dialog v-model="dialog" scrollable max-width="600px">
        <opening-hour-modal :opening-hours="form.opening_hours" @submit="saveOpeningHour" />
      </v-dialog>
    </v-row>
    <div class="row justify-center d-flex">
      <!--      <v-col sm="2"></v-col>-->
      <v-col cols="12">
        <v-simple-table class="branch-data">
          <template v-slot:default>
            <thead>
              <tr>
                <th style="display: none" class="text-center">id</th>
                <th class="text-center">Day</th>
                <th class="text-center">Open hour</th>
                <th class="text-center"></th>
                <th class="text-center">Show</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in form.opening_hours" :key="index">
                <td style="display: none">{{ data.id }}</td>
                <td>{{ data.day_en }}</td>
                <td>{{ data.time }}</td>
                <td>{{ data.status }}</td>
                <td>
                  <v-switch v-model="data.show_date"></v-switch>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col sm="2"></v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteLocation" @save-info="saveLocation" @save-close="saveClose"></command-button>
    <!--    <pre>{{form}}</pre>-->
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import InputTextField from "../../../components/Input/InputTextField";
import SelectOption from "../../../components/Input/selectOption";
import InputEditor from "../../../components/Input/InputEditor";
import InputTextArea from "../../../components/Input/InputTextArea";
import { mapState } from "vuex";
import SubmitButton from "../../../components/Button/SubmitButton";
import OpeningHourModal from "./OpeningHourModal";
import { permissionLocation, role } from "../../../util/Permission";
import Swal from "sweetalert";
import CommandButton from "../../../components/Layout/CommandButton";
import Loading from 'vue-loading-overlay';

export default {
  name: "LocationEdit",
  components: {
    CommandButton,
    OpeningHourModal,
    SubmitButton,
    InputTextArea,
    InputEditor,
    SelectOption,
    InputTextField,
    SaveButton,
    PreviewButton,
    DeleteButton,
    LineHr,
    TitleEdit,
    Loading
  },
  data() {
    return {
      optionBranch: [],
      optionMiniTCDC: [],
      dialog: false,
      openHours: [],
      permission: null,
      save_id: null,
      isLoading: false,
    }
  },
  created() {
    this.permission = role;
    this.getBranchData();
    this.getTCDCMini();
  },
  computed: {
    permissionLocation,
    ...mapState({
      form: state => {
        return state.Location.form;
      }
    })
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    getTCDCMini() {
      if (this.form.branch_id) {
        this.$store.dispatch("TCDCMini/getTCDCMiniByBranch", this.form.branch_id).then(res => {
          this.optionMiniTCDC = [
            { text: "Select", value: "" },
            ...res.map(data => ({
              value: data.id,
              text: data.branch_name_en,
            }))
          ];
        });
      }
    },
    validateData() {
      if (!this.form.branch_id) {
        Swal('', 'Please Select Branch', 'error');
        return false;
      } else if (!this.form.lat) {
        Swal('', 'Please input Latitude', 'error');
        return false;
      } else if (!this.form.lon) {
        Swal('', 'Please input Longitude', 'error');
        return false;
      } else if (!this.form.address_th) {
        Swal('', 'Please input Address TH', 'error');
        return false;
      } else if (!this.form.address_en) {
        Swal('', 'Please input Address EN', 'error');
        return false;
      }
      else {
        return true;
      }
    },
    saveClose() {
      if (this.validateData()) {
        this.$store.dispatch("Location/saveLocation", {
          id: this.save_id ? this.save_id : this.form.id,
          data: this.form
        }).then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToLocationTable();
          }
        }).catch(() => {
          Swal('', 'Cannot save data', 'error');
        });
      }
    },
    saveLocation() {
      this.isLoading = true;
      if (this.validateData()) {
        this.$store.dispatch("Location/saveLocation", {
          id: this.save_id ? this.save_id : this.form.id,
          data: this.form
        }).then(res => {
          this.save_id = res.result.id;
          this.isLoading = false;
          Swal(res.response_msg);
        }).catch(() => {
          this.isLoading = false;
          Swal('', 'Cannot save data', 'error');
        });
      }
    },
    goToLocationTable() {
      this.$router.push("/about/location");
    },
    async deleteLocation() {
      await this.$store.dispatch("Location/deleteLocation", this.form.id);
      Swal('ลบสำเร็จ');
    },
    showOpeningHour() {
      this.dialog = true;
    },
    saveOpeningHour(val) {
      if (val) {
        if (this.form.opening_hours && this.form.opening_hours.length > 0) {
          let i = 0
          for (const x of val) {
            this.form.opening_hours[i] = x;
            i++
          }
        } else {
          this.form.opening_hours = val;
        }
      }
      this.dialog = false;
    },
    updateBranch(val) {
      this.form.branch_id = val;
      this.getTCDCMini();
    },
    updateTcdcMini(val) {
      this.form.tcdc_mini_id = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateAddressTH(val) {
      this.form.address_th = val;
    },
    updateAddressEN(val) {
      this.form.address_en = val;
    },
    updatePostalAddressTH(val) {
      this.form.postal_address_th = val;
    },
    updatePostalAddressEN(val) {
      this.form.postal_address_en = val;
    },
    updateOpeningHoursDetailTH(val) {
      this.form.opening_hours_detail_th = val;
    },
    updateOpeningHoursDetailEN(val) {
      this.form.opening_hours_detail_en = val;
    },
    updateServiceAreaTitleTh(val) {
      this.form.service_area_title_th = val;
    },
    updateServiceAreaTitleEn(val) {
      this.form.service_area_title_en = val;
    },
    updateLat(val) {
      this.form.lat = val;
    },
    updateLon(val) {
      this.form.lon = val;
    },
    updateAttachedWebsite(val) {
      this.form.attached_website = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/variables.scss";

.branch-data {
  background-color: $background-theme;
  margin: $margin-search;
}
</style>
